import { IPortalDocumentResponse } from '../../../model/apm/document/portal-document-response';
import { useFeedback } from '../../../hooks/use-feedback';
import { fileDisplayName } from './document-utils';

interface DocumentAttachmentsOptions {
    // Registro dono dos anexos; sem ele (cadastro ainda não salvo) as ações são ignoradas
    ownerId?: number;
    files: IPortalDocumentResponse[];
    setFiles: (files: IPortalDocumentResponse[]) => void;
    upload: (ownerId: number, documentTypeId: number, file: File, onProgress: (percent: number) => void) => Promise<IPortalDocumentResponse>;
    remove: (ownerId: number, fileId: number) => Promise<void>;
    // Atualiza a grade (contador de anexos)
    onChange: () => void;
}

export function useDocumentAttachments({ ownerId, files, setFiles, upload, remove, onChange }: DocumentAttachmentsOptions) {
    const { showSuccess, showError, confirmDelete } = useFeedback();

    // Erros sobem para o componente de anexos, que os exibe junto ao campo
    async function handleUploadFile(documentTypeId: number, file: File, onProgress: (percent: number) => void) {
        if (!ownerId) return;
        const saved = await upload(ownerId, documentTypeId, file, onProgress);
        setFiles([...files, saved]);
        onChange();
        showSuccess('Documento anexado com sucesso!');
    }

    function handleDeleteFile(file: IPortalDocumentResponse) {
        if (!ownerId) return;
        confirmDelete(`Tem certeza que deseja excluir o anexo "${fileDisplayName(file)}"?`, async () => {
            try {
                await remove(ownerId, file.id);
                setFiles(files.filter((f) => f.id !== file.id));
                onChange();
                showSuccess('Anexo excluído com sucesso!');
            } catch (error: any) {
                showError('Não foi possível excluir o anexo', error);
            }
        });
    }

    return { handleUploadFile, handleDeleteFile };
}
